import { useField } from 'formik';
import { ChangeEvent, useMemo } from 'react';

import { Error } from './Error';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    name: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    /** Prevents Formik errors from showing. Useful for custom error handling. */
    hideError?: boolean;
}

export const Checkbox = ({
    name,
    id,
    value,
    onChange,
    placeholder,
    disabled,
    checked,
    children,
    hideError,
}: InputProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_field, meta] = useField(name);

    const showError = useMemo(() => !!meta.error && meta.touched, [meta.error, meta.touched]);

    return (
        <div className="space-y-2">
            <label className="flex items-start gap-2">
                <input
                    type="checkbox"
                    id={id}
                    name={name}
                    onChange={onChange}
                    value={value}
                    checked={checked}
                    placeholder={placeholder}
                    disabled={disabled}
                    className="transition-all duration-150 ease-in-out flex-shrink-0 w-4 h-4 border-2 border-neutral-500 bg-white mt-0.5 appearance-none rounded checked:bg-green-500 checked:border-green-500 text-white bg-center bg-no-repeat outline-2 outline outline-transparent focus:outline-green-200 outline-offset-0"
                    style={{
                        backgroundImage: `url(
                            "data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.33333L3.66667 9L9 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A"
                        )`,
                        backgroundSize: checked ? '9px' : '0',
                    }}
                />
                <span>{children}</span>
            </label>

            {showError && !hideError && <Error>{meta.error}</Error>}
        </div>
    );
};
